import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserInfoModel} from './user-info-model';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private userInfo: UserInfoModel;

  constructor(private httpClient: HttpClient) { }

  public get(): Observable<UserInfoModel> {
    if (this.userInfo != null) {
      return of<UserInfoModel>(this.userInfo);
    }

    return this.httpClient.get<UserInfoModel>('api/account/userinfo')
      .pipe(map(x => {
        this.userInfo = x;
        return x;
      }));
  }

  public async ping(): Promise<boolean> {
    // console.log('ping');
    // debugger;
    try {
      return await this.httpClient.get<Response>('api/account/ping', {observe: 'response'})
        .pipe(map(x => {
          console.log(x);
          return x.status === 200;
        })).toPromise();
    } catch (e) {
      return false;
    }
  }

  public async extendSession(): Promise<any> {
    try {
      return await this.httpClient.get<Response>('api/account/ExtendSession', {observe: 'response'})
        .pipe(map(x => {
          console.log(x);
          return x.status === 200;
        })).toPromise();
    } catch (e) {
      return false;
    }
  }
}
